import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessGoalsGoalSubgoalsRoute extends Route {
  model() {
    return this.modelFor('business.goals.goal');
  }
}

export default instrumentRoutePerformance(BusinessGoalsGoalSubgoalsRoute);
